<template>
    <dashboard-layout tit="1:1 문의하기">
        <template slot="contents">
            <router-view name="question"></router-view>
        </template>
    </dashboard-layout>
    <!-- <v-layout column justify-center>
        <v-sheet class="fill-height">
            <router-view name="question"></router-view>
        </v-sheet>
    </v-layout> -->
</template>

<script>
import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";

export default {
    components: {
        DashboardLayout,
    },
};
</script>

<style></style>
